import api from "../../../api/axios";

const DEFAULT_PAGE_SIZE = 20;

export function searchWritableClients(params = {}, { signal } = {}) {
  const { search, page = 1, page_size = DEFAULT_PAGE_SIZE } = params;
  const query = {
    page,
    page_size,
    ordering: "-created_at",
    writable: true,
  };
  if (search && String(search).trim()) {
    query.search = String(search).trim();
  }
  return api.get("/crm/clients/", { params: query, signal }).then((res) => res.data);
}

export function unwrapClientResults(data) {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

export function clientOptionLabel(client) {
  if (!client) return "";
  return (
    client.fullname ||
    `${client.first_name || ""} ${client.last_name || ""}`.trim() ||
    `Клієнт #${client.id}`
  );
}
